<!-- eslint-disable vue/no-v-html -->
<!--
  This page is derived by exporting the figma logos of the web design system located (at the time of writing) here:
  https://www.figma.com/file/CATKL9SGvim3nODq3a4h5C/Website---Design-System?node-id=754%3A1433
-->
<template>
  <div v-color-scheme="{ theme: 'fish' }" class="x-logo" :class="color">
    <x-icon
      v-if="compact"
      :icon="`fish-logo`"
      :width="width"
      :height="height"
    />
    <svg
      v-else
      :style="{ width, height }"
      :viewBox="viewBox"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- ON -->
      <path
        class="text"
        d="
        M5.00378 17.9687C3.62434 17.9687 2.67196 16.9513 2.67196 15.4754C2.67196 13.9995 3.62434 12.9821 5.00378 12.9821C6.38322 12.9821 7.3356 14.0033 7.3356 15.4754C7.3356 16.9475 6.38322 17.9687 5.00378 17.9687ZM5 20.4773C7.92517 20.4773 10 18.354 10 15.4754C10 12.5968 7.92517 10.4735 5 10.4773C2.07483 10.4773 0 12.5968 0 15.4754C0 18.354 2.07483 20.4773 5 20.4773Z
        M20.5105 20.4773H23.1247V10.4773H20.4402V16.0989L16.3634 10.4773H13.7497V20.4773H16.4341V14.8562L20.5105 20.4773Z
        "
      />

      <!-- SQUARE -->
      <path
        class="square"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="
        M62.7273 30.25H32.7273V0.25H62.7273V30.25Z
        M51.9281 22.125L54.6041 19.449L50.4053 15.25L54.6041 11.0507L51.9281 8.37503L47.7293 12.5736L43.5301 8.37503L40.8541 11.0507L45.0529 15.25L40.8541 19.449L43.5301 22.125L47.7293 17.9261L51.9281 22.125Z
        "
      />

      <!-- X -->
      <path
        class="x"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="
        M51.9281 22.125L54.6041 19.449L50.4053 15.25L54.6041 11.0507L51.9281 8.37503L47.7293 12.5736L43.5301 8.37503L40.8541 11.0507L45.0529 15.25L40.8541 19.449L43.5301 22.125L47.7293 17.9261L51.9281 22.125Z
        "
      />

      <path class="text" :d="verticalNamePath" />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import xIcon from '@/components/shared/x-icon/index.vue'
import { vColorScheme } from '@onxmaps/ys-tokens/vue'
import { verticalNamePaths } from '@/components/shared/x-logo/vertical-name-paths'

interface XLogoProps {
  color?: 'light' | 'dark'
  width?: string | number
  height?: string | number
  compact?: boolean
  hideAppName?: boolean
}

const props = withDefaults(defineProps<XLogoProps>(), {
  color: 'dark',
  compact: false,
  hideAppName: false,
  width: undefined,
  height: undefined,
})

const viewBox = computed(() => {
  const viewBox = '0 0 113 30'

  if (props.hideAppName) {
    return viewBox
  }

  return viewBox
})

const xFill = computed(() => {
  return 'var(--ys-color-text-reverse, #fff)'
})

const squareFill = computed(() => {
  return '#7DAD21'
})

const verticalNamePath = computed(() => {
  return verticalNamePaths['fish']
})
</script>
<style scoped>
.x-logo {
  font-size: 0;
}
.text {
  fill: var(--ys-color-text-primary, #333);
}

.square {
  fill: v-bind(squareFill);
}

.x {
  fill: v-bind(xFill);
}

.light .text {
  fill: var(--ys-color-text-reverse, #fff);
}
</style>
